import React, { FC } from 'react'

import { Toast } from './Toast'
import { ToasterProvider } from './ToasterContext'

type Props = Readonly<{
  className?: string
}>

export const Toaster: FC<Props> = ({ children, className }) => {
  return (
    <ToasterProvider>
      {toast => (
        <>
          {children}
          <div className={className}>
            {toast === undefined ? <></> : <Toast {...toast} />}
          </div>
        </>
      )}
    </ToasterProvider>
  )
}
